import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@foxera/environments/enviroment';
import { Observable } from 'rxjs';

export interface IVixeyExcludedPayload {
  exerciseId: string;
  branchId: string;
}

@Injectable({
  providedIn: 'root',
})
export class ExerciseService {
  private readonly URL = `${environment.api_fitness_base_url}/exercises`;

  constructor(private http: HttpClient) {}

  /**
   * Add exercise to Vixey excluded list (make it unavailable to Vixey)
   * POST /api/v1/exercises/vixey-excluded
   */
  addToVixeyExcluded(payload: IVixeyExcludedPayload): Observable<void> {
    return this.http.post<void>(`${this.URL}/vixey-excluded`, payload, {
      withCredentials: true,
    });
  }

  /**
   * Remove exercise from Vixey excluded list (make it available to Vixey)
   * DELETE /api/v1/exercises/vixey-excluded/branch/:branchid/exercise/:exerciseid
   */
  removeFromVixeyExcluded(branchId: string, exerciseId: string): Observable<void> {
    return this.http.delete<void>(
      `${this.URL}/vixey-excluded/branch/${branchId}/exercise/${exerciseId}`,
      {
        withCredentials: true,
      }
    );
  }
}
